<app-country-customer-selection
  [showHeader]="false"
  [countryControl]="countryControl"
  [customerControl]="customerControl"
  [disableCustomerInput]="!switchExternalUserStore.allCustomersCount()"
  [filteredCustomers]="switchExternalUserStore.getFilteredCustomers()"
  [selectedCustomer]="switchExternalUserStore.selectedCustomer()"/>
<app-sidebar-heartbeat [isLoading]="switchExternalUserStore.loading()"/>
